function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import React from 'react';
import classnames from 'classnames';
import T from 'prop-types';
var oppositeDirection = {
    left: 'right',
    right: 'left',
    down: 'up',
    up: 'down'
};
var getIcon = function(direction, isOpen) {
    return "caret-".concat(isOpen ? oppositeDirection[direction] : direction);
};
var MapButton = function(props) {
    var onClick = props.onClick, children = props.children, className = props.className, noPadding = props.noPadding;
    var _obj;
    return /*#__PURE__*/ React.createElement("button", {
        className: classnames('MapButton', (_obj = {}, _define_property(_obj, className, className), _define_property(_obj, "noPadding", noPadding), _obj)),
        onClick: onClick
    }, children);
};
MapButton.propTypes = {
    onClick: T.func,
    className: T.string
};
export default MapButton;
